import React from 'react';
import { Button, Radio } from 'antd';
import s from '../common.module.less';

interface Props {
    value?: boolean | null;
    onChange: (v: boolean) => void;
    onContinue: () => void;
    continueLabel?: string;
    // group 宿主（ProviderPayerModal）传 true：零侧边对齐标题、footer 分隔线通边
    flush?: boolean;
    onBack?: () => void;
    saving?: boolean;
}

const InfoIcon = () => (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="#60A5FA" aria-hidden>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
        />
    </svg>
);

export const NP104_TITLE = 'Blue Shield of California';
export const NP104_SUBTITLE =
    'Blue Shield of California only contracts nurse practitioners who hold the California 104 designation.';

// 原型 showNp104Modal（10/26）：加州执照的 NP 选了 Blue Shield of California 时，链的第一步。
// 只有 Yes / No（查不到，所以没有 Not sure）；No 的后果（从选择里去掉、不收押金）由宿主在 Continue 时处理
const Np104Step = ({ value, onChange, onContinue, onBack, saving, continueLabel = 'Continue', flush }: Props) => {
    let radioValue: 'Yes' | 'No' | undefined;
    if (value != null) radioValue = value ? 'Yes' : 'No';
    return (
        <>
            <div className={`${s.modalBody} ${flush ? s.flushBody : ''}`}>
                <p className={s.np104Question}>Do you hold the California 104 NP designation?</p>
                <p className={s.np104Desc}>
                    104 is the certification to practice independently in California. It is not your NP license, your
                    furnishing number (NPF), or a 103. You can see it under Qualification on{' '}
                    <a href="https://search.dca.ca.gov" target="_blank" rel="noopener noreferrer">
                        search.dca.ca.gov
                    </a>
                    .
                </p>
                <Radio.Group value={radioValue} onChange={(e) => onChange(e.target.value === 'Yes')}>
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                </Radio.Group>
                {value === false && (
                    <div className={`${s.infoBox} ${s.np104No}`}>
                        <InfoIcon />
                        <span>
                            We will take Blue Shield of California off your list, so there is no deposit for it. Your
                            other payers are not affected. Once you have the 104 designation, add Blue Shield of
                            California from Add payers on your Credentialing page.
                        </span>
                    </div>
                )}
            </div>
            <div className={`${s.modalFooter} ${flush ? s.flushFooter : ''}`}>
                <Button
                    type="primary"
                    block
                    size="large"
                    className={s.primaryBtn}
                    disabled={value == null}
                    loading={saving}
                    onClick={onContinue}
                >
                    {continueLabel}
                </Button>
                {onBack && (
                    <Button block size="large" className={s.backBtn} onClick={onBack}>
                        Back
                    </Button>
                )}
            </div>
        </>
    );
};

export default Np104Step;
